// src/App.js
import React, { useState } from 'react';
import Header from './components/Header/Header';
import MainContent from './components/MainContent/MainContent';
import '../src/styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ContactPage from './components/ContactPage';

function App() {
  const [originalAudioFile, setOriginalAudioFile] = useState(null);
  const [candidateAudioFile, setCandidateAudioFile] = useState(null);

  const handleSubmit = () => {
    if (!originalAudioFile && !candidateAudioFile) {
      alert('Please provide either an audio file or a YouTube link');
      return;
    }
    
    setOriginalAudioFile(null);
    setCandidateAudioFile(null);
  };

  return (
    <div className="app-container">
      <Router>
        <Header /> 
        <Routes>
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/" element={<MainContent 
            originalAudioFile={originalAudioFile}
            setOriginalAudioFile={setOriginalAudioFile}
            candidateAudioFile={candidateAudioFile}
            setCandidateAudioFile={setCandidateAudioFile}
            handleSubmit={handleSubmit}
          />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;